
/**
 * Joydeco DE — Dynamic EUR Display Localization
 *
 * DE: 1.299,99 €
 * EN: €1,299.99
 *
 * Display-only:
 * - Does not modify price calculations
 * - Does not modify VO price data attributes
 * - Does not change cart submissions
 */

(() => {
  "use strict";

  const root = document.querySelector(
    'main-product, [id^="MainProduct-"]'
  );

  if (!root) return;

  const language = document.documentElement.lang
    .toLowerCase()
    .split("-")[0];

  const isGerman = language === "de";

  const formatter = new Intl.NumberFormat(
    isGerman ? "de-DE" : "en-US",
    {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  );

  function formatAmount(value) {
    const cleaned = String(value)
      .replace(/[^\d.,-]/g, "");

    if (!cleaned) return null;

    const lastComma = cleaned.lastIndexOf(",");
    const lastDot = cleaned.lastIndexOf(".");

    let normalized = cleaned;

    if (lastComma > lastDot) {
      normalized = cleaned
        .replace(/\./g, "")
        .replace(",", ".");
    } else if (lastDot > lastComma) {
      normalized = cleaned.replace(/,/g, "");
    } else if (lastComma !== -1) {
      normalized = cleaned.replace(",", ".");
    }

    const amount = Number(normalized);

    if (!Number.isFinite(amount)) return null;

    return formatter.format(amount);
  }

  function localizePriceText(text) {
    return String(text).replace(
      /€\s*-?[\d.,]+|-?[\d.,]+\s*€/g,
      match => formatAmount(match) || match
    );
  }

  function updateElement(element) {
    if (!element) return;

    const original = element.textContent;
    const localized = localizePriceText(original);

    if (original !== localized) {
      element.textContent = localized;
    }
  }

  function updatePrices() {
    root.querySelectorAll(
      '.product-price .price-item--sale, ' +
      '.product-price .price-item--regular, ' +
      '#bcpo .bcpo-addon, ' +
      '#bcpo .bcpo-value'
    ).forEach(updateElement);
  }

  let updating = false;

  function scheduleUpdate() {
    if (updating) return;

    updating = true;

    requestAnimationFrame(() => {
      updating = false;
      updatePrices();
    });
  }

  const observer = new MutationObserver(scheduleUpdate);

  observer.observe(root, {
    childList: true,
    subtree: true,
    characterData: true
  });

  updatePrices();
})();
